// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__BoHCu","header":"PatientBlock_header__1p15A","label":"PatientBlock_label__2k6vK","option":"PatientBlock_option__3jBJy"};